const teamMembers = [
  {
    id: 1,
    name: "Sarah JiaXuan Wang",
    projectRole: "Project Manager, Product Co-Owner, and Frontend Developer",
    personalStatement: "I blend creativity, strategy, and code to build seamless, user-centered digital experiences driven by curiosity about how people think, feel, and interact.",
    linkedin: "https://www.linkedin.com/in/sarah-jx-wang",
    github: "https://github.com/sarah-wang",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/sarah.png"
  },
  {
    id: 2,
    name: "Esteban Cruz D.",
    projectRole: "Product Co-Owner and Lead Developer",
    personalStatement: "I lead development by turning design ideas into scalable, functional systems, while also choosing the right infrastructure, UI libraries, and tasks to bring the project to life.",
    linkedin: "https://www.linkedin.com/in/esteban-cruz-dominguez-1b2418325/",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/esteban.png"
  },
  {
    id: 3,
    name: "Mateusz Matyskiewicz",
    projectRole: "Graphic Designer",
    personalStatement: "I bring a structured, detail-oriented approach to design, combining graphic design with UI/UX methodology to create purposeful and user-focused visual systems.",
    linkedin: "https://www.linkedin.com/in/mateusz-matyskiewicz-62aa9b335/",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/mateusz.png"
  },
  {
    id: 4,
    name: "Angel Hsieh",
    projectRole: "UI/UX Designer",
    personalStatement: "I design intuitive, user-focused interfaces that make tasks simple and visually cohesive, solving usability challenges and creating experiences that feel effortless for users.",
    linkedin: "https://www.linkedin.com/in/angel-hsieh-97a85b240/",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/angel.png"
  },
  {
    id: 5,
    name: "Rosie Lee",
    projectRole: "Lead Designer and Scrum Master",
    personalStatement: "I design research-driven solutions that combine simplicity and purposeful storytelling to solve real problems.",
    linkedin: "https://www.linkedin.com/in/rosie-bh-lee",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/rosie.png"
  },
  {
    id: 6,
    name: "Hyunjung Shin",
    projectRole: "Marketing Specialist and Designer",
    personalStatement: "I specialize in user-centered UX/UI design, combining research-driven insights with thoughtful interface design to create intuitive and impactful digital experiences.",
    linkedin: "https://www.linkedin.com/in/hyunjungs",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/hyunjung.png"
  },
  {
    id: 7,
    name: "Zinna Kim",
    projectRole: "Backend Developer",
    personalStatement: "I bridge technical development and social media strategy to deliver meaningful, user-driven digital experiences.",
    linkedin: "https://www.linkedin.com/in/seoyoung-kim-910508327",
    github: "https://github.com/zinna-k",
    profilePicture: process.env.PUBLIC_URL + "/solaceHeadhsots/zinna.png"
  }
];

export default teamMembers;
